import React from 'react';
import { Progress } from 'antd';
import { Fragment } from 'react';
import { formatNumberWithComma } from '../../../helpers';

const ProgressBar = (props) => {
    const { data } = props;
    const { percent, initialBalance, currentBalance, nameCatFeature, unlimited } = data;

    const renderUsage = () => {
        if(!unlimited) 
            return `- ${percent}%`;
        return null;
    }

    const renderQuantity = () => {
        if(!unlimited)
            return `${formatNumberWithComma(currentBalance)} de ${formatNumberWithComma(initialBalance)}`
        else 
            return `ilimitado`;
    }
    
    return(
        <Fragment>
            <p className="margin-0 " style={{margin: '10px  0 0',color: '#8C8C8C'}}>
               <span className="em">{nameCatFeature} {renderUsage()}</span>
            </p>            
            { unlimited &&  <p className="margin-0 ">ilimitado </p>}           
            { !unlimited && 
            
                <div className="progress-bar-container">
                    <Progress showInfo={true} percent={percent} status={percent === 100 ? 'exception' : 'success'}/>
                    <span  color={{ color: '#030A1E' }}className="em label">{renderQuantity()}</span>
                </div>
            }
            <div className="line" style={{margin: '10px 0'}}></div>
        </Fragment>
    );
}

export default ProgressBar;